export const ANNUAL_DISCOUNT = 0.25;

export function getExchangeRate(): number {
  const raw = process.env.NEXT_PUBLIC_EXCHANGE_RATE_USD_RUB;
  const rate = raw ? parseFloat(raw) : 100;
  return isFinite(rate) && rate > 0 ? rate : 100;
}

const _rate = getExchangeRate();

export const PRICING_CONFIG = {
  starter: { usd: 149, rub: Math.round(149 * _rate) },
  pro:     { usd: 299, rub: Math.round(299 * _rate) },
};

export const ANNUAL_PRICING = {
  starter: {
    usdPerMonth: Math.round(149 * (1 - ANNUAL_DISCOUNT)),
    rubPerMonth: Math.round(149 * (1 - ANNUAL_DISCOUNT) * _rate),
    rubPerYear:  Math.round(149 * (1 - ANNUAL_DISCOUNT) * _rate * 12),
  },
  pro: {
    usdPerMonth: Math.round(299 * (1 - ANNUAL_DISCOUNT)),
    rubPerMonth: Math.round(299 * (1 - ANNUAL_DISCOUNT) * _rate),
    rubPerYear:  Math.round(299 * (1 - ANNUAL_DISCOUNT) * _rate * 12),
  },
};

export const IMPLEMENTATION_PACKAGES = {
  starter:    { rub: 0,      weeks: 2 },
  pro:        { rub: 150000, weeks: 4 },
  enterprise: { rub: null,   weeks: null },
} as const;

export type PricingTierKey = keyof typeof PRICING_CONFIG;
export type BillingPeriod = "monthly" | "annual";

export function formatPriceUSD(tier: PricingTierKey): string {
  return `$${PRICING_CONFIG[tier].usd}`;
}

export function formatPriceRUB(tier: PricingTierKey, billing: BillingPeriod = "monthly"): string {
  const rub = billing === "annual"
    ? ANNUAL_PRICING[tier].rubPerMonth
    : PRICING_CONFIG[tier].rub;
  return `₽${rub.toLocaleString("ru-RU")}`;
}
